import { USE_FEDERATION } from './federation/config';
import * as federation from './federation/officeTrips';
import * as legacy from './legacy/officeTrips';
export const GET_ACTIVE_TRIP = USE_FEDERATION
    ? federation.GET_ACTIVE_TRIP
    : legacy.GET_ACTIVE_TRIP;
export const GET_NEXT_TRIP = USE_FEDERATION
    ? federation.GET_NEXT_TRIP
    : legacy.GET_NEXT_TRIP;
export const NEW_TRIP_HAS_ALREADY_STARTED = USE_FEDERATION
    ? federation.NEW_TRIP_HAS_ALREADY_STARTED
    : legacy.NEW_TRIP_HAS_ALREADY_STARTED;
export const TRIP_REQUEST_START = USE_FEDERATION
    ? federation.TRIP_REQUEST_START
    : legacy.TRIP_REQUEST_START;
export const TRIP_REQUEST_ARRIVE = USE_FEDERATION
    ? federation.TRIP_REQUEST_ARRIVE
    : legacy.TRIP_REQUEST_ARRIVE;
export const TRIP_REQUEST_ONBOARD = USE_FEDERATION
    ? federation.TRIP_REQUEST_ONBOARD
    : legacy.TRIP_REQUEST_ONBOARD;
export const TRIP_REQUEST_FINISH = USE_FEDERATION
    ? federation.TRIP_REQUEST_FINISH
    : legacy.TRIP_REQUEST_FINISH;
export const LIST_TRIP_STATIONS = USE_FEDERATION
    ? federation.LIST_TRIP_STATIONS
    : legacy.LIST_TRIP_STATIONS;
export const SET_STATUS_WAITING_FOR_ORDER = USE_FEDERATION
    ? federation.SET_STATUS_WAITING_FOR_ORDER
    : legacy.SET_STATUS_WAITING_FOR_ORDER;
export const SET_STATUS_OFFLINE = USE_FEDERATION
    ? federation.SET_STATUS_OFFLINE
    : legacy.SET_STATUS_OFFLINE;
export const CREATE_TRIP_REQUEST = USE_FEDERATION
    ? federation.CREATE_TRIP_REQUEST
    : legacy.CREATE_TRIP_REQUEST;
export const TRIPS_STATIONS_AUTOCOMPLETE = USE_FEDERATION
    ? federation.TRIPS_STATIONS_AUTOCOMPLETE
    : legacy.TRIPS_STATIONS_AUTOCOMPLETE;
export const TRIPS_REQUEST_COMPLAINT = USE_FEDERATION
    ? federation.TRIPS_REQUEST_COMPLAINT
    : legacy.TRIPS_REQUEST_COMPLAINT;
export const REJECT_TRIP_REQUEST = USE_FEDERATION
    ? federation.REJECT_TRIP_REQUEST
    : legacy.REJECT_TRIP_REQUEST;
export const WAITING_PLANNED_LIST_TRIPS = USE_FEDERATION
    ? federation.WAITING_PLANNED_LIST_TRIPS
    : legacy.WAITING_PLANNED_LIST_TRIPS;
